module.exports = __webpack_public_path__ + "OpenSans-LightItalic-97534dd409492b05b11ab96b3dd4a557.woff";